import { WorkOrderList } from "./components/WorkOrderList";

export default function App() {
  return (
    <div className="min-h-screen">

      <WorkOrderList />
    </div>
  );
}